var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-btn"},[_c('i',{staticClass:"budicon-cross-sign"}),_c('span',[_vm._v("Avbryt")])])
}]

export { render, staticRenderFns }